import React from 'react';
import GenericImage from './GenericImage';
import { segmentTrackEvent } from '../utils.js';

const Lander = ({
	hed,
    subHed,
	intro,
	author,
	bgImage,
	textImage,
	isMobile,
}) => {

	// const renderedGATags = createGATags(image.gaLabel);
     const landerTracker = {
      destinationUrl: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/KilzChecklist.pdf',
      module: 'destiLander',
      category: 'text-link',
      linkType: 'text-link',
      label: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/KilzChecklist.pdf',
    };
	return (
		<div className='lander'>
			<div className='lander-wrapper'>
				<img src={isMobile ? textImage.mobile : textImage.desktop} className="lander-text-img"></img>
				<div className='lander-text-wrapper'>
					<h1 className='lander-hed'>{hed}</h1>
					<div className='lander-subhed'dangerouslySetInnerHTML={{ __html: subHed }}></div>
                	<div className="lander-line"></div>
                    <div className='lander-text' dangerouslySetInnerHTML={{ __html: intro }} onClick={() => segmentTrackEvent("article_clicked", landerTracker)}></div>
                </div>
			</div>
		</div>
	)
};

export default Lander;